import { useDispatch, useSelector } from "react-redux";
import { ramactions } from "../store/index";
const useCustomquesrystring = (clear=false) => {
  const resourceType = useSelector((state) => state.resourceType);
  const languages = useSelector((state) => state.languages);
  const communities = useSelector((state) => state.communities);
  const accessibility = useSelector((state) => state.accessibility);
  const cost = useSelector((state) => state.cost);
  const dispatch = useDispatch();  
  let langParams = "";
  if (languages.length === 0 || clear === true) {
    //const langarr = ["any"];
    //dispatch(ramactions.updateLanguages(langarr));
    langParams = "any";
  } else {
    const selectedlangvalueunique = languages.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });
    langParams = selectedlangvalueunique.toString();
  }
  //console.log("Anish!!");
  //console.log(languages);

  //communities
  let communitiesParams = "";
  if (communities.length === 0 || clear === true) {
    //const communitiesarr = ["any"];
    //dispatch(ramactions.updateCommunities(communitiesarr));
    communitiesParams = "any";
  } else {
    const selectedCommunitiesvalueunique = communities.filter(
      (value, index, self) => {
        return self.indexOf(value) === index;
      }
    );
    communitiesParams = selectedCommunitiesvalueunique.toString();
  }

  //accessibility
  let accessibilityParams = "";
  if (accessibility.length === 0 || clear === true) {
    //dispatch(ramactions.updateAccessibility(["any"]));
    accessibilityParams = "any";
  } else {
    const selectedAccessibilityvalueunique = accessibility.filter(
      (value, index, self) => {
        return self.indexOf(value) === index;
      }
    );
    accessibilityParams = selectedAccessibilityvalueunique.toString();
  }
  //console.log(accessibility);

  //cost
  let costParams = "";
  if (cost.length === 0 || clear === true) {
    //dispatch(ramactions.updateCost(["any"]));
    costParams = "any";
  } else {
    const selectedCostvalueunique = cost.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });
    costParams = selectedCostvalueunique.toString();
  }
  //console.log(cost);

  //resource type
  let resourceTypeParams = "";
  if (resourceType.length === 0 || clear === true) {
    //dispatch(ramactions.updateResourceType(["any"]));
    resourceTypeParams = "hotline,physical";
  } else {
    const selectedResourceTypevalueunique = resourceType.filter(
      (value, index, self) => {
        return self.indexOf(value) === index;
      }
    );
    resourceTypeParams = selectedResourceTypevalueunique.toString();
  }

  if (resourceTypeParams === "any" || clear === true)
    resourceTypeParams = "hotline,physical";
  //if (showclear === false) resetFilter();

  return {
    langParams: langParams,
    resourceTypeParams: resourceTypeParams,
    costParams: costParams,
    accessibilityParams: accessibilityParams,
    communitiesParams: communitiesParams,
  };
};

export default useCustomquesrystring;
